export const CLIENT_ID_HEADER = 'X-Payaca-Client';

export const CLIENT_IDS = [
  'webapp-admin',
  'webapp-provider',
  'webapp-client',
  'field-service-mobile',
  'legacy-mobile-app',
] as const;

export type KnownClientId = (typeof CLIENT_IDS)[number];
export type ClientId = KnownClientId | 'unknown';
